import { render } from "./DocumentPDFConfig.vue?vue&type=template&id=641e3d84"
import script from "./DocumentPDFConfig.vue?vue&type=script&lang=js"
export * from "./DocumentPDFConfig.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/flow/evaluate/DocumentPDFConfig.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "641e3d84"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('641e3d84', __exports__)) {
    api.reload('641e3d84', __exports__)
  }
  
  module.hot.accept("./DocumentPDFConfig.vue?vue&type=template&id=641e3d84", () => {
    api.rerender('641e3d84', render)
  })

}


export default __exports__